export default {
  created () {
    this.singleActions = [
      {
        label: this.$t('table.action.modify'),
        permission: 'mcp_servers_update',
        action: obj => {
          this.createDialog('McpConfigDialog', {
            type: 'edit',
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
          })
        },
        meta: () => ({
          validate: true,
        }),
      },
      {
        label: this.$t('ai.mcp.set_default'),
        permission: 'mcp_servers_update',
        action: obj => {
          this.createDialog('SetDefaultAgentDialog', {
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            success: this.refresh,
          })
        },
      },
      {
        label: this.$t('cloudenv.text_108'),
        permission: 'mcp_servers_delete',
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: this.$t('cloudenv.text_108'),
            name: this.$t('ai.mcp.title'),
            onManager: this.onManager,
          })
        },
      },
    ]
  },
}
